import { Stack, Title } from '@mantine/core';
import { useId, type ReactNode } from 'react';

type Props = {
  title: string;
  children: ReactNode;
};

/** Groupe de la vue détail SUS : même titre que la section correspondante du formulaire. */
const SusDetailSection = ({ title, children }: Props) => {
  const titleId = useId();

  return (
    <Stack gap="xs" component="section" aria-labelledby={titleId}>
      <Title id={titleId} order={3} size="lg" c="var(--mantine-primary-color-filled)">
        {title}
      </Title>
      {children}
    </Stack>
  );
};

export default SusDetailSection;
